import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { BoltDimensionModel } from '../../../models';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-thread-type-bolt-size',
    templateUrl: './thread-type-bolt-size.component.html',
    styleUrls: ['./thread-type-bolt-size.component.scss'],
    standalone: false
})
export class ThreadTypeBoltSizeComponent implements OnInit {
    @Input()
    set boltType(value: string) {
        if (value) {
            this._boltType = value;
            this.loadThreadTypes();
        }
    }
    get boltType(): string {
        return this._boltType;
    }
    @Input() form: UntypedFormGroup;
    @Output() selected: EventEmitter<BoltDimensionModel> = new EventEmitter();
    @Output() redAreaBoltLoad: EventEmitter<string> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    loadingBoltSize: boolean = false;
    boltDimensionList: BoltDimensionModel[];
    threadTypeList: string[];
    boltSizeList: BoltDimensionModel[];
    MinorDiameterInternal: string;
    private _boltType: string;

    constructor(
        private iceapi: IceapiService,
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService
    ) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();
        this.form
            .get('threadType')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.getBoltSize(value);
                this.form.markAllAsTouched();
            });
    }

    getBoltSize(threadType: string): void {
        this.form.markAllAsTouched();
        this.loadingBoltSize = true;
        this.iceapi
            .getBoltDimensions(this.boltType == 'Metric', threadType)
            .pipe(
                finalize(() => {
                    this.loadingBoltSize = false;
                    this.cd.markForCheck();
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
                if (res.success) {
                    this.boltSizeList = res.response;
                    this.globalEmittersService.boltSizeList.next(this.boltSizeList);
                    this.cd.markForCheck();
                    this.MinorDiameterInternal = this.boltDimensionList.find(
                        (x) => x.boltSizeName == this.boltDimensionList[0].boltSizeName
                    ).minorDiameterInternal.imperial.stringValue;

                    if (this.boltSizeList.length === 1) {
                        this.form.get('boltSize').setValue(this.boltSizeList[0].boltDimensionId, { emitEvent: false });
                        this.MinorDiameterInternal = this.boltDimensionList.find(
                            (x) => x.boltSizeName == this.boltDimensionList[0].boltSizeName
                        ).minorDiameterInternal.imperial.stringValue;
                        alert(this.MinorDiameterInternal);
                    }
                } else {
                    this.user_utility.errorModelPopup(res.message);
                }
            });
    }

    async loadThreadTypes() {
        if (this.boltType != undefined) {
            this.loading = true;
            await this.getBoltDimensions();
            if (this.boltDimensionList) {
                this.threadTypeList = this.boltDimensionList.map((item) => item.threadSeries).filter((value, index, self) => self.indexOf(value) === index);

                this.threadTypeList = this.threadTypeList.sort((a, b) => {
                    let resp1 = parseInt(a.substring(0, 2));
                    let resp2 = parseInt(b.substring(0, 2));
                    return resp1 - resp2;
                });

                this.loading = false;
                this.cd.markForCheck();
            }
            let res = this.boltDimensionList.find((x) => this.form.get('threadType').value == x.boltDimensionId);
            if (this.form.get('threadType').value !== '') {
                this.getBoltSize(this.form.get('threadType').value);
            }

            if (this.threadTypeList.length == 1) {
                this.form.get('threadType').setValue(this.threadTypeList[0], { emitEvent: false });
            }
        }
    }

    async getBoltDimensions() {
        this.loading = true;
        let response = await this.iceapi.getBoltDimensions(this.boltType == 'Metric').toPromise();
        this.loading = false;
        if (response.success) {
            this.boltDimensionList = response.response;
            if (this.boltDimensionList.length === 1) this.form.get('boltSize').setValue(this.boltDimensionList[0].boltDimensionId, { emitEvent: false });
        } else if (response.isCustom) {
            this.user_utility.errorModelPopup(response.message);
        }
        this.cd.markForCheck();
    }

    selectBoltSize(selectedValue: MatSelectChange): void {
        const selection = this.boltSizeList.find((x) => x.boltDimensionId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
        }
    }

    selectthreadType(selectedValue: MatSelectChange): void {
        const selection = this.threadTypeList.find((x) => x === selectedValue.value);
        if (selection) {
            this.form.get('redAreaBolt').setValue('', { emitEvent: false });
            this.redAreaBoltLoad.emit('');
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
